import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setNewReviewFormOpen } from '../../../actions/newReview';
import { requestAuthentication } from '../../../actions/authentication';
import { setNewQuestionFormOpen } from '../../../actions/newQuestion';
import { getIsAuthenticated } from '../../../selectors/user';

export const OPEN_NEW_REVIEW_HASH = '#new-review';
export const OPEN_NEW_QUESTION_HASH = '#new-question';

export const useFormsOpener = () => {
  const isAuthenticated = useSelector(getIsAuthenticated);
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (window) {
      const hash = window.location.hash;

      if (hash === OPEN_NEW_REVIEW_HASH) {
        if (isAuthenticated) {
          dispatch(setNewReviewFormOpen());
        } else {
          dispatch(requestAuthentication({ onSuccess: setNewReviewFormOpen }));
        }
      }

      if (hash === OPEN_NEW_QUESTION_HASH) {
        if (isAuthenticated) {
          dispatch(setNewQuestionFormOpen());
        } else {
          dispatch(requestAuthentication({ onSuccess: setNewQuestionFormOpen }));
        }
      }
    }
  }, []);
};
